import { GraphBarType } from '../../../enums/graphBarType'
import { BarLayout } from '../../../types/barLayout'
import { BarRadius } from '../../../types/barRadius'

const BAR_RADIUS = 4

interface GetBarRadiusProps {
  barLayout: BarLayout
  barType: GraphBarType
  paid: number
  unpaid: number
}

export const getBarRadius = ({ barLayout, barType, paid, unpaid }: GetBarRadiusProps): BarRadius => {
  if (paid === 0 && unpaid === 0) {
    return 0
  }

  if (barLayout === 'horizontal') {
    return BAR_RADIUS
  }

  const isSingleBar = paid <= 0 || unpaid <= 0 || barType === GraphBarType.Paid

  return isSingleBar ? [BAR_RADIUS, BAR_RADIUS, 0, 0] : BAR_RADIUS
}
